import { NgModule } from '@angular/core';
import { AbstractAddComponent } from './add/abstract-add/abstract-add.component';
import { AbstractAddWmodalComponent } from './add/abstract-add-wmodal/abstract-add-wmodal.component';
import { AbstractPageAddComponent } from './add/abstract-page-add/abstract-page-add.component';
import { AbstractDetailsComponent } from './details/abstract-details/abstract-details.component';
import { AlertDecourseDetailsComponent } from './alert-decourse-details/alert-decourse-details.component';

@NgModule({
    imports: [],
    exports: [AbstractAddComponent, AbstractAddWmodalComponent, AbstractPageAddComponent,
        AbstractDetailsComponent, AlertDecourseDetailsComponent],
    declarations: [AbstractAddComponent, AbstractAddWmodalComponent, AbstractPageAddComponent,
        AbstractDetailsComponent, AlertDecourseDetailsComponent],
    providers: [],
})
export class AbstractsModule { }
